/**
 * EditorLoadingSkeleton — sl-e0il.1.3
 *
 * Suspense fallback rendered while the lazy-loaded CodeMirror chunk is
 * being fetched. Two variants: block (default, multi-line editors) and
 * inline (single-line `TemplateInput`). Both reserve roughly the height
 * of the eventual editor so the config panel doesn't jump on hydration.
 */

import { useI18n } from '@affine/i18n';

import * as styles from './editor.css';

export interface EditorLoadingSkeletonProps {
  variant?: 'block' | 'inline';
}

export function EditorLoadingSkeleton({
  variant = 'block',
}: EditorLoadingSkeletonProps) {
  const t = useI18n();
  return (
    <div
      role="status"
      aria-live="polite"
      className={
        variant === 'inline'
          ? styles.editorSkeletonInline
          : styles.editorSkeleton
      }
    >
      {t['com.streamlain.streamlain.workflow.editor.loading']()}
    </div>
  );
}
